import { Sparkles, UserPen, User } from "lucide-react";

export const Logo = ({ size = 32, sub = true }) => (
  <div className="flex items-center gap-2.5" data-testid="praniq-logo">
    <svg width={size} height={size} viewBox="0 0 40 40" aria-label="PranIQ emblem">
      <polygon points="20,2 36,11 36,29 20,38 4,29 4,11" fill="none" stroke="#0284C7" strokeWidth="3" strokeLinejoin="round" />
      <polyline points="8,21 14,21 17,13 22,28 25,21 32,21" fill="none" stroke="#0D9488" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <div className="leading-none">
      <div className="font-heading font-extrabold text-[17px] text-sky-700 tracking-tight">PranIQ</div>
      {sub && <div className="text-[10px] text-slate-500 mt-0.5 tracking-wide">Protocol Engine</div>}
    </div>
  </div>
);

const S = {
  draft: "bg-slate-100 text-slate-700 border-slate-300", in_review: "bg-amber-50 text-amber-800 border-amber-300",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-300", published: "bg-sky-50 text-sky-800 border-sky-300",
  superseded: "bg-purple-50 text-purple-800 border-purple-300", retired: "bg-rose-50 text-rose-800 border-rose-300",
  verified: "bg-emerald-50 text-emerald-800 border-emerald-300", unverified: "bg-amber-50 text-amber-800 border-amber-300",
};
const DOT = { draft: "bg-slate-400", in_review: "bg-amber-500", approved: "bg-emerald-500", published: "bg-sky-500", superseded: "bg-purple-500", retired: "bg-rose-500", verified: "bg-emerald-500", unverified: "bg-amber-500" };

export const StatusBadge = ({ status, testid }) => (
  <span data-testid={testid || `status-badge-${status}`} className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${S[status] || S.draft}`}>
    <span className={`h-1.5 w-1.5 rounded-full ${DOT[status] || DOT.draft}`} />
    {String(status || "").replace("_", " ")}
  </span>
);

export const SampleBadge = () => (
  <span data-testid="sample-badge" className="inline-flex items-center rounded border border-red-300 bg-red-50 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-red-700">
    Sample – not clinically approved
  </span>
);

export const ProvTag = ({ prov }) => {
  if (!prov) return null;
  const m = {
    ai: ["By PranIQ AI", "bg-violet-50 text-violet-700 border-violet-200", Sparkles],
    ai_human_edited: ["AI → human edited", "bg-indigo-50 text-indigo-700 border-indigo-200", UserPen],
    human: ["Human-written", "bg-slate-50 text-slate-600 border-slate-200", User],
  }[prov.origin];
  if (!m) return null;
  const Icon = m[2];
  return (
    <span data-testid={`prov-tag-${prov.origin}`} title={prov.model ? `Model: ${prov.model}` : ""} className={`inline-flex items-center gap-1 rounded border px-1.5 py-px text-[10px] font-medium ${m[1]}`}>
      <Icon size={10} /> {m[0]}
    </span>
  );
};

export const Section = ({ title, children, right, testid }) => (
  <section className="card-surface p-4 sm:p-5 fade-in" data-testid={testid}>
    <div className="mb-3 flex items-center justify-between gap-2">
      <h3 className="font-heading text-[15px] font-bold text-slate-900">{title}</h3>
      {right}
    </div>
    {children}
  </section>
);
